import Keycloak from 'keycloak-js';

import { requiredEnv } from './runtimeEnv';
import { isJustLoggedOut } from './utils/authStorage';
import { DEFAULT_POST_AUTH_PATH } from './rbac/landingPage';

export function getKeycloakRedirectUri(): string {
  // A previous user explicitly logged out in this browser. The URL currently in the
  // address bar belongs to THAT user's session (e.g. a deep link they had open) and must
  // not be reused as the landing target for whoever logs in next. Send them to the app
  // root instead, where permission-based landing-page resolution decides where to go.
  if (isJustLoggedOut()) {
    return window.location.origin + DEFAULT_POST_AUTH_PATH;
  }
  // /unauthorized is a dead-end status page, never a genuine destination — e.g. a role
  // switch made the previous screen inaccessible, or a stale token forced re-auth while
  // it was showing. Returning here would just re-show the same message.
  if (window.location.pathname.replace(/\/+$/, '').startsWith('/unauthorized')) {
    return window.location.origin + DEFAULT_POST_AUTH_PATH;
  }
  // Otherwise this is a genuine first-time / deep-link visit (e.g. a bookmarked or shared
  // URL opened while signed out) — preserve it so the user lands where they intended.
  return window.location.href;
}

const keycloak = new Keycloak({
   url: requiredEnv('VITE_KEYCLOAK_AUTH_URL'),
   realm: requiredEnv('VITE_KEYCLOAK_REALM'),
   clientId: requiredEnv('VITE_KEYCLOAK_CLIENT_ID'),
  // url: "https://auth-csm-agd.inova.lk",
  // realm: "CMS_INTERNAL",
  // clientId: "INTERNAL_PORTRAL",
});

export default keycloak;